import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Preloader = () => {
    const [done, setDone] = useState(false);
    const [count, setCount] = useState(0);

    useEffect(() => {
        const start = performance.now();
        let raf;
        const tick = (now) => {
            const p = Math.min(100, Math.round(((now - start) / 1600) * 100));
            setCount(p);
            if (p < 100) raf = requestAnimationFrame(tick);
            else setTimeout(() => setDone(true), 350);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, []);

    return (
        <AnimatePresence>
            {!done && (
                <motion.div
                    exit={{ y: '-100%' }}
                    transition={{ duration: 1, ease: [0.77, 0, 0.175, 1] }}
                    className="fixed inset-0 z-[100] bg-[#0A0A0B] text-white flex flex-col justify-between p-6 md:p-10"
                >
                    <div className="flex justify-between overline text-white/60">
                        <span>Indian Industrial Distributors</span>
                        <span>EST. 1985</span>
                    </div>
                    <div className="flex items-end justify-between">
                        <div className="h-display text-[24vw] md:text-[18vw] leading-none">
                            {String(count).padStart(3, '0')}<span className="text-[#FF3B00]">%</span>
                        </div>
                        <div className="overline text-white/60 pb-4 hidden md:block">Loading assets</div>
                    </div>
                    <div className="h-[2px] w-full bg-white/10 relative overflow-hidden">
                        <motion.div
                            initial={{ width: '0%' }}
                            animate={{ width: `${count}%` }}
                            transition={{ ease: 'linear' }}
                            className="absolute inset-y-0 left-0 bg-[#FF3B00]"
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Preloader;
